import React from 'react';
import { TradingScoreWidgetConfig } from './types';
import { getWidgetIcon } from '../../../registry';

interface TradingScoreWidgetBuilderProps {
  config: Partial<TradingScoreWidgetConfig>;
  onChange: (config: TradingScoreWidgetConfig) => void;
}

const TradingScoreWidgetBuilder: React.FC<TradingScoreWidgetBuilderProps> = () => {
  return (
    <div className="space-y-4">
      <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 text-sm text-warning-800">
        <strong>Action Buttons Template</strong>
        <p className="mt-1">
          This creates a reusable action button selector. No configuration is needed here.
        </p>
      </div>

      <div className="border rounded-lg p-4 bg-primary-50 border-primary-200">
        <h4 className="font-medium text-primary-800 mb-2 flex items-center gap-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          How it works
        </h4>
        <ul className="text-sm text-primary-700 space-y-2 ml-7 list-disc">
          <li>Create this template to make action buttons available</li>
          <li>Users choose one action at a time from six fixed actions</li>
          <li>The selected action is stored at the dashboard data key for the widget instance</li>
          <li>The widget is designed for quick, clear selection with minimal setup</li>
        </ul>
      </div>

      <div className="border rounded-lg p-3 bg-surface">
        <label className="block text-sm font-medium text-neutral-700 mb-2">
          Preview
        </label>
        <div className="flex items-center gap-3 p-4 bg-neutral-50 rounded border">
          <span className="text-4xl">{getWidgetIcon('trading_score')}</span>
          <div>
            <p className="font-medium text-neutral-900">Action Buttons</p>
            <p className="text-sm text-neutral-500">
              Single-select action group with six fixed choices
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingScoreWidgetBuilder;
